import { useState, useEffect, useCallback, memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { PostSummary } from './Summary/PostsSummary.jsx';
import { SinglePost } from './SinglePost.jsx';
import Tooltip from '../../../../shared/Tooltip/Tooltip.jsx';

export const PostsContainer = memo(
  ({ posts, campaignUuid, campaignEndDate }) => {
    const { t } = useTranslation('posts');
    const [sortedPosts, setSortedPost] = useState(posts);
    const [sortOrder, setSortOrder] = useState({
      order: 'asc',
      title: t('postSummary.sortAsc'),
    });

    const sortByDate = useCallback(
      option => {
        const sorted = [...posts].sort((a, b) => {
          const dateA = new Date(a.publishDate);
          const dateB = new Date(b.publishDate);

          return option.order === 'asc' ? dateA - dateB : dateB - dateA;
        });

        setSortedPost(sorted);
        setSortOrder(option);
      },
      [posts, setSortedPost, setSortOrder],
    );

    useEffect(() => {
      sortByDate(sortOrder);
    }, [sortOrder, sortByDate]);

    return (
      <Posts>
        <PostSummary
          sortByDate={sortByDate}
          posts={sortedPosts}
          campaignUuid={campaignUuid}
          sortOrder={sortOrder}
        />
        <Container>
          {sortedPosts.map(post => {
            return (
              <SinglePost
                key={post.uuid}
                post={post}
                campaignUuid={campaignUuid}
                campaignEndDate={campaignEndDate}
              />
            );
          })}
          <Tooltip id="tooltip-live-post" />
        </Container>
      </Posts>
    );
  },
);

PostsContainer.displayName = 'PostsContainer';

const Posts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 676px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin: 0px 0px 36px;
`;
